const NON_DELETABLE_SEGMENTS = ['anonymous', 'authenticated'];

export {
  NON_DELETABLE_SEGMENTS,
};
